export default "__VITE_ASSET__6b55b7d2__"